import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a4c05d84"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row justify-start full-width" }
const _hoisted_2 = { class: "col-auto" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Micronutrientes", -1))
const _hoisted_4 = {
  key: 0,
  class: "full-width text-center"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Nutrientes", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Extração da Cultura", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Exportação da Cultura", -1))
const _hoisted_8 = { class: "recomendations-line" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Recomendação Nutricional", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "NORTOX Aplicado", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Saldo - deve ser zerado", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Macronutrientes", -1))
const _hoisted_13 = {
  key: 1,
  class: "full-width text-center"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Nutrientes", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Extração da Cultura", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Exportação da Cultura", -1))
const _hoisted_17 = { class: "recomendations-line" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Recomendação Nutricional", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "NORTOX Aplicado", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Saldo - deve ser zerado", -1))
const _hoisted_21 = {
  key: 2,
  class: "col-12"
}
const _hoisted_22 = {
  key: 0,
  class: "row"
}
const _hoisted_23 = { class: "row justify-center full-width q-mt-xl" }
const _hoisted_24 = { class: "col-auto" }

import { api } from '@/utils';
import { Category } from '@/models/category';
import { Formula } from '@/models/formula';
import { CategoryFormula } from '@/models/category-formula';
import FormulaAdjustTables from './components/FormulaAdjustTables.vue';
import { plainToInstance } from 'class-transformer';
import { ReportAnalysisItem } from '@/models/report-analysis-item';
import store from '@/store';
import { Substance } from '@/models/substance';
import useQuasar from 'quasar/src/composables/use-quasar.js';;
import { computed, ref, onMounted, onBeforeMount, onBeforeUnmount} from 'vue';
import { useRoute, useRouter } from 'vue-router';

interface SubstanceValue {
  substanceCode: string;
  value: number | string;
}

interface CategoryTableGroup {
  category: Category;
}

interface Substances {
  thisTablesId: number;
  substances: number[];
}

type SubstancesArray = Substances[];


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const quasar = useQuasar();
const route = useRoute();
const router = useRouter();

const reportAnalysisItems = ref<ReportAnalysisItem[]>([]);
const formulas = ref<Formula[]>([]);
const substances = ref<Substance[]>([]);
const categories = ref<Category[]>([]);
const tableGroups = [];

let formulas_usadas = ref<CategoryFormula[]>([]);

const producaoEsperada = ref<any>(1);

let arraysSubstances = ref<any>([]);

let microSubstances = [];

const macroSubstances = [];

let microNortoxApplied = ref<string[]>(['0', '0', '0', '0', '0', '0']);
let macroNortoxApplied = ref<string[]>(['0', '0', '0', '0', '0', '0']);
let ca 
let mg 

let microNortoxAppliedSubstance = ref<string[]>([]);
let macroNortoxAppliedSubstance = ref<string[]>([]);

let nortoxAppliedSubstance = ref<string[]>([]);

let microBalanceAux = ref<string[]>([]);
let macroBalanceAux = ref<string[]>([]);

const getExportationAndExtraction = (array: SubstanceValue[], substance: Substance, s: String) => {
  let value = getValueFromSubstance(array, substance);

  if (value == 0) {
    value = 1;
  }

  value = (producaoEsperada.value / 1000) * value;

  /* const id_substances_to_multiply = [7, 8, 9, 10, 11];

  if(
    id_substances_to_multiply.find(element => element == substance.id) 
    && 
    s == "extraction"
  )
  {
    value = value*1.5;
  } */

  return value.toFixed(2);
};

const exportation = computed<SubstanceValue[]>(() => {
  return substances.value.map((substance) => {
    const value =
      reportAnalysisItems.value.find((reportAnalysisItem) => {
        return reportAnalysisItem.analysisItem.identifier === `Exportacao${substance.code}`;
      })?.value || 0;

    const substanceCode = substance.code;

    return { substanceCode, value };
  });
});

const extraction = computed<SubstanceValue[]>(() => {
  return substances.value.map((substance) => {
    const value =
      reportAnalysisItems.value.find((reportAnalysisItem) => {
        return reportAnalysisItem.analysisItem.identifier === `Extracao${substance.code}`;
      })?.value || 0;

    const substanceCode = substance.code;

    return { substanceCode, value };
  });
});

const necessity = computed<SubstanceValue[]>(() => {
  return substances.value.map((substance) => {
    const value =
      reportAnalysisItems.value.find((reportAnalysisItem) => {
        return reportAnalysisItem.analysisItem.identifier === `Necessidade${substance.code}`;
      })?.value || 0;

    const substanceCode = substance.code;

    return { substanceCode, value };
  });
});

const getValueFromSubstance = (array: SubstanceValue[], substance: Substance) => {
  const itemValue = array.find((el) => el.substanceCode === substance.code)?.value;

  let value = 0;
  if (typeof itemValue === 'number') {
    value = itemValue;
  } else if (typeof itemValue === 'string') {
    value = Number.parseFloat(itemValue);
  }

  return value;
};

const getTextValueFromSubstance = (array: SubstanceValue[], substance: Substance) => {
  return Number.parseFloat(getValueFromSubstance(array, substance).toFixed(3));
};

const soilContents = computed<SubstanceValue[]>(() => {
  return substances.value.map((substance) => {
    const value =
      reportAnalysisItems.value.find((reportAnalysisItem) => {
        return reportAnalysisItem.analysisItem.identifier === `${substance.code}NoSolo`;
      })?.value || 0;

    const substanceCode = substance.code;

    return { substanceCode, value };
  });
});

const recomendations = computed<SubstanceValue[]>(() => {
  return substances.value.map((substance) => {
    const value =
      reportAnalysisItems.value.find((reportAnalysisItem) => {
        return reportAnalysisItem.analysisItem.identifier === `Necessidade${substance.code}`;
      })?.value || 0;

    const substanceCode = substance.code;

    return { substanceCode, value };
  });
});
const init = () => {

  quasar.loading.show();
  
  api
    .get(`category-formula/${route.params.id}`)
    .then((response) => {
      formulas_usadas.value = plainToInstance(CategoryFormula, response.data);
      api
        .get(`category`)
        .then((response) => {
          categories.value = plainToInstance(Category, response.data);
        })
        .catch((error) => {
          console.log('Erro ao obter dados das categorias.', error.response);
        });
    })
    .catch((error) => {
      console.log('Erro ao obter dados das FORMULAS USADAS.', error.response);
    });

  api
    .get(`report/${route.params.id}/recomendations`)
    .then((response) => {

      quasar.loading.hide();
      
      reportAnalysisItems.value = plainToInstance(ReportAnalysisItem, response.data.analysisItems);
      formulas.value = plainToInstance(Formula, response.data.formulas);
      substances.value = plainToInstance(Substance, response.data.substances);

      // macroNortoxApplied[3] = Ca // CaAdicionado
      // macroNortoxApplied[4] = Mg //MgAdicionado



      ca = reportAnalysisItems.value.find((item) => {
        return item.analysisItem.identifier == 'CaAdicionado'
      })
      mg = reportAnalysisItems.value.find((item) => {
        return item.analysisItem.identifier == 'MgAdicionado'
      })

      macroNortoxApplied.value[3] = parseFloat(ca?.value*400).toFixed(3);
      macroNortoxApplied.value[4] = parseFloat(mg?.value*243).toFixed(3);



      store.dispatch('getRecomendationsFromAPI', {
        formulas: formulas.value,
        substances: substances,
        reportAnalysisItems: reportAnalysisItems,
      });

      substances.value.forEach(function (att) {
        if (att.unit == 'g') {
          microSubstances.push(att);
        }
        if (att.unit == 'kg') {
          macroSubstances.push(att);
        }
      });

      producaoEsperada.value = reportAnalysisItems.value.find((dado) => dado.analysisItemId == 2);

      if (producaoEsperada.value) {
        producaoEsperada.value = parseFloat(producaoEsperada.value.value);
      }

      prepareDataForResults(microSubstances, macroSubstances);
    })
    .catch((error) => {
      console.log('Erro ao obter dados de recomendações do teste.', error.response);
    });

  
};

function getDataFromTables(data) {

  const result = arraysSubstances.value.find((dado) => dado.thisTablesId === data.thisTablesId);

  if (result) {
    arraysSubstances.value = arraysSubstances.value.filter(
      (item) => item.thisTablesId !== data.thisTablesId
    );
    arraysSubstances.value.push(data);
  } else {
    arraysSubstances.value.push(data);
  }

  store.commit('setSubstancesApplied', arraysSubstances.value);

  sumValuesFromTables(arraysSubstances.value);
}

function sumValuesFromTables(arr) {
  let auxString = `${arr[0].name} | ${arr[0].dose} | ${arr[0].application}`;

  let sumTables = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

  microNortoxAppliedSubstance.value = [];
  macroNortoxAppliedSubstance.value = [];

  nortoxAppliedSubstance.value = [];

  arr.forEach(function (item, index) {
    for (let i = 0; i < 12; i++) {
      sumTables[i] = sumTables[i] + parseFloat(item.substances[i]);
    }
    auxString = `${item.thisTablesTitle} | ${item.name} | ${item.dose} | ${item.application}`;
    nortoxAppliedSubstance.value.push(auxString);
  });

  microNortoxApplied.value = [];
  macroNortoxApplied.value = [];

  sumTables.forEach(function (item, index) {
    if (index < 6) {
      macroNortoxApplied.value.push(item.toFixed(2));
    } else {
      microNortoxApplied.value.push(item.toFixed(2));
    }
  });


    macroNortoxApplied.value[3] = (parseFloat(macroNortoxApplied.value[3]) + parseFloat(ca?.value*400)).toFixed(3);
    macroNortoxApplied.value[4] = (parseFloat(macroNortoxApplied.value[4]) + parseFloat(mg?.value*243)).toFixed(3);


  prepareDataForResults(microSubstances, macroSubstances);
}

function prepareDataForResults(micro, macro) {
  let microRecomendations = [];
  let microSoilContents = [];
  let microExportation = [];
  let microExtraction = [];
  let microNecessity = [];
  let microBalance = ['0', '0', '0', '0', '0', '0'];

  let macroRecomendations = [];
  let macroSoilContents = [];
  let macroExportation = [];
  let macroExtraction = [];
  let macroNecessity = [];
  let macroBalance = ['0', '0', '0', '0', '0', '0'];

  micro.forEach(function (item, index) {
    microRecomendations.push(getTextValueFromSubstance(recomendations.value, item));
    microSoilContents.push(getTextValueFromSubstance(soilContents.value, item));
    microExportation.push(getExportationAndExtraction(exportation.value, item));
    microExtraction.push(getExportationAndExtraction(extraction.value, item, "extraction"));
    microNecessity.push(getTextValueFromSubstance(necessity.value, item));
  });

  macro.forEach(function (item, index) {
    macroRecomendations.push(getTextValueFromSubstance(recomendations.value, item));
    macroSoilContents.push(getTextValueFromSubstance(soilContents.value, item));
    macroExportation.push(getExportationAndExtraction(exportation.value, item));
    macroExtraction.push(getExportationAndExtraction(extraction.value, item, "extraction"));
    macroNecessity.push(getTextValueFromSubstance(necessity.value, item));
  });

  let microNortoxAppliedValues = microNortoxApplied.value;
  let macroNortoxAppliedValues = macroNortoxApplied.value;

  let microSubstancesString = [];
  let macroSubstancesString = [];

  substances.value.forEach(function (item, index) {
    if (index > 5) {
      microSubstancesString.push(`${item.utf8Code}(${item.unit})`);
    } else {
      macroSubstancesString.push(`${item.utf8Code}(${item.unit})`);
    }
  });


  for (var i = 0; i < 6; i++) {
    microBalance[i] = (
      parseFloat(microNortoxAppliedValues[i]) -
      parseFloat(microNecessity[i])
    ).toFixed(2);
    macroBalance[i] = (
      parseFloat(macroNortoxAppliedValues[i]) -
      parseFloat(macroNecessity[i])
    ).toFixed(2);
  }

  store.dispatch('getBalanceFromRecomendations', {
    microBalance: microBalance,
    macroBalance: macroBalance,
  });

  microBalanceAux.value = microBalance;
  macroBalanceAux.value = macroBalance;

  let nortoxAppliedSubstancesString = nortoxAppliedSubstance.value;

  let data = {
    nortoxAppliedSubstancesString,

    microRecomendations,
    microSoilContents,
    microExportation,
    microExtraction,
    microNecessity,
    microNortoxAppliedValues,
    microBalance,
    microSubstancesString,

    macroRecomendations,
    macroSoilContents,
    macroExportation,
    macroExtraction,
    macroNecessity,
    macroNortoxAppliedValues,
    macroBalance,
    macroSubstancesString,
  };

  store.dispatch('getDataToResults', data);

  return data;
}

function backEditReport(){
  quasar.loading.show();
  api
    .post(`category-formula/${route.params.id}`, {
      data: store.state.substancesApplied,
    })
    .then((response) => {
      quasar.loading.hide();
      router.push(`/teste/${route.params.id}/editar`)
    })
    .catch((error) => {
      quasar.loading.hide();
      console.log('Erro ao fazer a chamada a API para salvar as formulas por categorias', error.response);
    });
}

function saveResults(){
  quasar.loading.show();
  api
    .post(`category-formula/${route.params.id}`, {
      data: store.state.substancesApplied,
    })
    .then((response) => {
      quasar.loading.hide();
      router.push(`/teste/${route.params.id}/resultados`);
    })
    .catch((error) => {
      quasar.loading.hide();
      console.log('Erro ao fazer a chamada a API para salvar as formulas por categorias', error.response);
    });
}

// TODO: Terminar de atribuir os valores de recomendação

init();

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_q_btn, {
          flat: "",
          color: "primary",
          label: "Editar relatório",
          class: "text-bold",
          icon: "chevron_left",
          dense: "",
          onClick: backEditReport
        })
      ])
    ]),
    _hoisted_3,
    (substances.value.length > 0)
      ? (_openBlock(), _createElementBlock("table", _hoisted_4, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _hoisted_5,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(microSubstances), (substance, substanceIndex) => {
                return (_openBlock(), _createElementBlock("th", { key: substanceIndex }, _toDisplayString(substance.utf8Code) + " (" + _toDisplayString(substance.unit) + ") ", 1))
              }), 128))
            ])
          ]),
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", null, [
              _hoisted_6,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(microSubstances), (substance, substanceIndex) => {
                return (_openBlock(), _createElementBlock("td", { key: substanceIndex }, _toDisplayString(getExportationAndExtraction(_unref(extraction), substance)), 1))
              }), 128))
            ]),
            _createElementVNode("tr", null, [
              _hoisted_7,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(microSubstances), (substance, substanceIndex) => {
                return (_openBlock(), _createElementBlock("td", { key: substanceIndex }, _toDisplayString(getExportationAndExtraction(_unref(exportation), substance, "extraction")), 1))
              }), 128))
            ]),
            _createElementVNode("tr", _hoisted_8, [
              _hoisted_9,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(microSubstances), (substance, substanceIndex) => {
                return (_openBlock(), _createElementBlock("td", { key: substanceIndex }, _toDisplayString(getTextValueFromSubstance(_unref(recomendations), substance)), 1))
              }), 128))
            ]),
            _createElementVNode("tr", null, [
              _hoisted_10,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(microNortoxApplied), (microApplied, index) => {
                return (_openBlock(), _createElementBlock("td", { key: index }, _toDisplayString(microApplied), 1))
              }), 128))
            ]),
            _createElementVNode("tr", null, [
              _hoisted_11,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.state.BalanceFromRecomendations.microBalance, (microBalance, index) => {
                return (_openBlock(), _createElementBlock("td", { key: index }, _toDisplayString(microBalance), 1))
              }), 128))
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _hoisted_12,
    (substances.value.length > 0)
      ? (_openBlock(), _createElementBlock("table", _hoisted_13, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _hoisted_14,
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(macroSubstances, (substance, substanceIndex) => {
                return _createElementVNode("th", { key: substanceIndex }, _toDisplayString(substance.utf8Code) + " (" + _toDisplayString(substance.unit) + ") ", 1)
              }), 64))
            ])
          ]),
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", null, [
              _hoisted_15,
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(macroSubstances, (substance, substanceIndex) => {
                return _createElementVNode("td", { key: substanceIndex }, _toDisplayString(getExportationAndExtraction(_unref(extraction), substance)), 1)
              }), 64))
            ]),
            _createElementVNode("tr", null, [
              _hoisted_16,
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(macroSubstances, (substance, substanceIndex) => {
                return _createElementVNode("td", { key: substanceIndex }, _toDisplayString(getExportationAndExtraction(_unref(exportation), substance)), 1)
              }), 64))
            ]),
            _createElementVNode("tr", _hoisted_17, [
              _hoisted_18,
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(macroSubstances, (substance, substanceIndex) => {
                return _createElementVNode("td", { key: substanceIndex }, _toDisplayString(getTextValueFromSubstance(_unref(recomendations), substance)), 1)
              }), 64))
            ]),
            _createElementVNode("tr", null, [
              _hoisted_19,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(macroNortoxApplied), (macroApplied, index) => {
                return (_openBlock(), _createElementBlock("td", { key: index }, _toDisplayString(macroApplied), 1))
              }), 128))
            ]),
            _createElementVNode("tr", null, [
              _hoisted_20,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.state.BalanceFromRecomendations.macroBalance, (macroBalance, index) => {
                return (_openBlock(), _createElementBlock("td", { key: index }, _toDisplayString(macroBalance), 1))
              }), 128))
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (categories.value.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
          (_ctx.$store.state.dataRecomendations)
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categories.value, (category, index) => {
                  return (_openBlock(), _createBlock(FormulaAdjustTables, {
                    key: index,
                    index: index,
                    title: category.name,
                    category: category,
                    formulas: _ctx.$store.state.dataRecomendations.formulas,
                    substances: substances.value,
                    formulasUsadas: _unref(formulas_usadas),
                    onSendDataToRecomendationsComponent: getDataFromTables
                  }, null, 8, ["index", "title", "category", "formulas", "substances", "formulasUsadas"]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("div", _hoisted_24, [
        _createVNode(_component_q_btn, {
          label: "Resultados",
          color: "primary",
          onClick: saveResults
        })
      ])
    ])
  ], 64))
}
}

})